import { type MaybeRef, get } from '@vueuse/core'
import { type Ref, onBeforeUnmount, shallowRef, watch } from 'vue'

/** Optional, scoped destination for support actions while a form needs the viewport. */
export const floatingRailAnchor = shallowRef<HTMLElement | null>(null)

export function useInlineFloatingRail(
	anchor: Ref<HTMLElement | null>,
	enabled: MaybeRef<boolean>
) {
	let owned: HTMLElement | null = null
	watch(
		[anchor, () => get(enabled)],
		([element, active]) => {
			if (element && active) {
				owned = element
				floatingRailAnchor.value = element
			} else if (floatingRailAnchor.value === owned) {
				floatingRailAnchor.value = null
			}
		},
		{ flush: 'post', immediate: true }
	)
	onBeforeUnmount(() => {
		if (floatingRailAnchor.value === owned) floatingRailAnchor.value = null
	})
}
